import React from 'react';
import DataRequestGuide from '../../components/DataRequestGuide';
const steps = [
  {
    id: 'chatgpt-step-1',
    stepLabel: 'Step 1',
    title: 'Where should you begin?',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step1.png',
    imageAlt: 'ChatGPT home screen with menu icon highlighted',
    body: (
      <>
        Open the ChatGPT app or go to{' '}
        <a href="https://chatgpt.com" target="_blank" rel="noreferrer">
          chatgpt.com
        </a>
        , then press on the two horizontal bars at the top left of the screen.
        (If the side menu is already visible, you can skip this step.)
      </>
    ),
  },
  {
    id: 'chatgpt-step-2',
    stepLabel: 'Step 2',
    title: 'Open your profile menu',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step2.png',
    imageAlt: 'Profile icon highlighted in ChatGPT',
    body: (
      <>
        Click on your profile icon, located where your username appears at the
        bottom left of the menu.
      </>
    ),
  },
  {
    id: 'chatgpt-step-3',
    stepLabel: 'Step 3',
    title: 'Go to settings',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step3.png',
    imageAlt: 'Settings option highlighted in menu',
    body: (
      <>
        In the pop-up menu, click on <strong>Settings</strong>.
      </>
    ),
  },
  {
    id: 'chatgpt-step-4',
    stepLabel: 'Step 4',
    title: 'Open data controls',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step4.png',
    imageAlt: 'Data controls button highlighted in settings',
    body: (
      <>
        In the settings panel, press the <strong>Data controls</strong> button.
      </>
    ),
  },
  {
    id: 'chatgpt-step-5',
    stepLabel: 'Step 5',
    title: 'Export your data',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step5.png',
    imageAlt: 'Export data button highlighted',
    body: (
      <>
        In the Data controls menu, click on the <strong>Export</strong> button
        next to “Export data”.
      </>
    ),
  },
  {
    id: 'chatgpt-step-6',
    stepLabel: 'Step 6',
    title: 'Confirm export',
    image: process.env.PUBLIC_URL + '/Images/steps/GPT_Step6.png',
    imageAlt: 'Confirm export dialog',
    body: (
      <>
        Click on <strong>Confirm export</strong>. You will receive a
        downloadable link to your email after some time. Once you have
        downloaded the data, come back to the{' '}
        <a href="/donate">Data Donation</a> page on this site to submit it.
      </>
    ),
  },
];

const ChatGPTRequest = () => {
  return (
    <DataRequestGuide
      title="How to Request Your ChatGPT Data"
      intro="Follow these steps to export a copy of your ChatGPT data, which you can then donate through this website."
      steps={steps}
    />
  );
};

export default ChatGPTRequest;
